import { render, staticRenderFns } from "./EditModgroupItem.vue?vue&type=template&id=2bb6cdb8&scoped=true"
import script from "./EditModgroupItem.vue?vue&type=script&lang=ts"
export * from "./EditModgroupItem.vue?vue&type=script&lang=ts"
import style0 from "./EditModgroupItem.vue?vue&type=style&index=0&id=2bb6cdb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6cdb8",
  null
  
)

export default component.exports